import { render, staticRenderFns } from "./TopicContent.vue?vue&type=template&id=548d9173&scoped=true&"
import script from "./TopicContent.vue?vue&type=script&lang=js&"
export * from "./TopicContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "548d9173",
  null
  
)

export default component.exports